/* Variables */
const closePopUp = document.querySelector(".btn-pop-up-close");
const closePopUpView = document.querySelector(".cartlink-popup-close-view");
const closeOverlay = document.querySelector(".overly-mini-cart");
const cartPopupItems = JSON.parse(sessionStorage.getItem("CART_ITEMS_V1"));

closePopUp?.addEventListener("click", closeModal);
closePopUpView?.addEventListener("click", closeModal);
closeOverlay?.addEventListener("click", closeModal);

/* functions and events */
document.addEventListener("DOMContentLoaded", () => {
  const popUp = document.querySelector(".pop-up");
  // popUp.style.visibility = 'hidden';
  // popUp.style.opacity = '0';
});

function closeModal() {
  updateItemsNumber();
  const popUp = document.querySelector(".pop-up");
  popUp.classList.remove("active");
  // popUp.style.visibility = 'hidden';
  // popUp.style.opacity = '0';
  // $("html").removeClass("modal-open");
}

/* add cart customize */
async function addCartItem(variantId, qty = 1) {
  try {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty,
      }),
    });

    return result.json();
  } catch (e) {
    return new Error("error no se pudo agregar al carrito");
  }
}

async function getCartItems() {
  const result = await fetch("/cart.json");

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(
    `Failed to get request, Shopify returned ${result.status} ${result.statusText}`
  );
}

function clearItems() {
  const listCart = document.querySelector(".pop-up-container");

  if (!listCart) return;

  while (listCart.firstChild) {
    listCart.removeChild(listCart.firstChild);
  }
}

function showModal() {
  updateItemsNumber();
  printMinicartProducts();
  const popUp = document.querySelector(".pop-up");

  if (!popUp) return;

  // popUp.style.visibility = 'visible';
  // popUp.style.opacity = '1';
  popUp.classList.add("active");
  // $("html").addClass("modal-open");
}

async function printMinicartProducts() {
  const listCart = document.querySelector(".pop-up-container");
  const cartData = await getCartItems();
  const itemsB = await cartData.items;

  $("#total-minicart").text(
    `Total: $${Math.round(cartData.total_price / 100).toLocaleString()}`
  );

  clearItems();

  try {
    if (cartData.item_count > 0) {
      itemsB.forEach((item) => {
        const itemPopupCart =
          cartPopupItems.find((cartItem) => cartItem.id == item.id) || item;

        let price = item.original_price / 100;
        var variant = undefined;
        if (item.variant_options[0] === "Default Title") variant = "";
        else variant = "- " + item.variant_options[0];

        listCart.innerHTML += `
                     <div class="card-product-minicart" id="cart-item-${
                       item.id
                     }">
                         <div class="minicart-content-image">
                             <img src="${item.featured_image.url}">
                         </div>
                         <div class="minicart-content-info">
                            <h2 class="pop-up-text">
                                <a href="${item.url}">
                                    ${item.product_title.substring(
                                      0,
                                      20
                                    )} ${variant}
                                </a>
                            </h2>
                            <p class="pop-up-text">$${Math.round(
                              price
                            ).toLocaleString()}</p>
                            <div class="variants">
                                <ul class="content-item-cart">
                                    <li class="quantity-mini-cart">
                                        <div class="btn-cart" onClick="minusItemToCart(${
                                          item.id
                                        }, ${item.quantity})">-</div>
                                        <input class="quantity__input" value="${
                                          item.quantity
                                        }" min="0" max="${
          itemPopupCart.inventoryQuantity
        }" data-inventory-quantity="${
          itemPopupCart.inventoryQuantity
        }" aria-label="${item.title}" data-change-quantity-id="${
          item.id
        }" onChange="changeInput(${item.id}, this)">
                                        <div class="btn-cart" data-quantity="${
                                          item.id
                                        }" data-inventory-quantity="${
          itemPopupCart.inventoryQuantity
        }" onClick="plusItemToCart(event, ${item.id}, ${item.quantity})">+</div>
                                    </li>
                                    <div class="delete-product-minicart" data-id="${
                                      item.id
                                    }" onclick="deleteProductMiniCart(${
          item.id
        })">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32.594" height="35.882" viewBox="0 0 32.594 35.882">
                                            <g id="Icon_feather-trash-2" data-name="Icon feather-trash-2" transform="translate(1.5 1.5)">
                                                <path id="Trazado_12202" data-name="Trazado 12202" d="M4.5,9H34.094" transform="translate(-4.5 -2.424)" fill="none" stroke="#db2128" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                <path id="Trazado_12203" data-name="Trazado 12203" d="M30.518,9.576V32.594a3.288,3.288,0,0,1-3.288,3.288H10.788A3.288,3.288,0,0,1,7.5,32.594V9.576m4.932,0V6.288A3.288,3.288,0,0,1,15.721,3H22.3a3.288,3.288,0,0,1,3.288,3.288V9.576" transform="translate(-4.212 -3)" fill="none" stroke="#db2128" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                <path id="Trazado_12204" data-name="Trazado 12204" d="M15,16.5v9.865" transform="translate(-3.491 -1.703)" fill="none" stroke="#db2128" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                <path id="Trazado_12205" data-name="Trazado 12205" d="M21,16.5v9.865" transform="translate(-2.915 -1.703)" fill="none" stroke="#db2128" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                            </g>
                                        </svg>
                                    </div>
                                </ul>
                            </div>
                         </div>
                     </div>
                `;
      });
    } else {
      listCart.innerHTML += `<h1 class="empty-car-message">Carrito Vacio</h1>`;
    }
  } catch (error) {}
}

async function addToCart(variantId, qty = 1) {
  try {
    if (qty != 1) {
      await addCartItem(variantId, qty);
    } else {
      await addCartItem(variantId);
    }
    // showModal();

    document.querySelectorAll("mini-cart-drawer").forEach(async (item) => {
      await item.refreshCart(null, true);
    });
  } catch (e) {
    console.log(e);
  }
}

function deleteProductMiniCart(idItem) {
  jQuery.post("/cart/update.js", `updates[${idItem}]=0`).then((resp) => resp);

  setTimeout(function () {
    printMinicartProducts();
  }, 1000);
}

function plusItemToCart(event, variantId, itemQuantity) {
  let newQuantity = itemQuantity + 1;
  let inventoryQuantity = parseInt(event.target.dataset.inventoryQuantity);

  if (newQuantity > inventoryQuantity) {
    $(`input[data-change-quantity-id="${event.target.dataset.quantity}"]`).val(
      inventoryQuantity
    );
    newQuantity = inventoryQuantity;
  }

  jQuery.post("/cart/update.js", `updates[${variantId}]=${newQuantity}`);

  setTimeout(function () {
    printMinicartProducts();
  }, 500);
}

function minusItemToCart(variantId, itemQuantity) {
  let newQuantity = itemQuantity - 1;
  jQuery
    .post("/cart/update.js", `updates[${variantId}]=${newQuantity}`)
    .then((resp) => resp);
  setTimeout(function () {
    printMinicartProducts();
  }, 500);
}

function changeInput(variantId, element) {
  let newValue = parseInt($(element).val());
  let inventoryQuantity = parseInt(element.dataset.inventoryQuantity);

  if (newValue > inventoryQuantity) {
    $(element).val(inventoryQuantity);
    newValue = inventoryQuantity;
  }

  setTimeout(function () {
    jQuery
      .post("/cart/update.js", `updates[${variantId}]=${newValue}`)
      .then((resp) => resp);
  }, 500);
}

$(".icon-cart").click(function () {
  setTimeout(function () {
    showModal();
  }, 1000);
});

async function updateItemsNumber() {
  const cartItems = await getCartItems();
  if (cartItems) {
    $(".cart-number").html(cartItems.item_count);
  }
}
